import React from "react";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "./select-field.component";
import { Field, Form, Formik, FastField } from "formik";
import { object, string } from "yup";
import { TextField } from "formik-material-ui";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography/Typography";
import Table from "@material-ui/core/Table";
import {
  TriggeringTextField,
  onNameChange,
} from "./triggering-text-field.component";
import { REQUEST_PERIODS } from "../utils/cancel.constants.js";
/** PUBLIC */

export const valencesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/valences")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const adminOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/admins", { name, admin_group_ids: [4, 5], active: true })
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const countriesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/countries")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const type_searchesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/type_searches")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const sourcesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/sources")
    .then((res) => res.data)
    .then(optionsToSelect);
};

//PARENTESCO
export const relatednessOptionsPromise = async () => {
  const api = new Api();
  const res = await api.get("/relatedness");
  const options = res.data;
  return optionsToSelect(options);
};

/*CONCELHOS*/
export const countiesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/counties")
    .then((res) => res.data)
    .then(optionsToSelect);
};

/*FREGUESIAS*/
export const parishesOptionsPromise = (county) => {
  const api = new Api();
  return () =>
    api
      .get("/parishes", { county }, true)
      .then((res) => res.data)
      .then(optionsToSelect);
};

export const shouldUpdateSelect = (prevProps, props) => {
  const updatedDependentValue =
    prevProps.formik.values[prevProps.dependsOn] !==
    props.formik.values[prevProps.dependsOn];
  const updatedValue = prevProps.value !== props.value;
  return updatedValue || updatedDependentValue;
};

/** PRIVATE */

const validationSchema = object().shape({
  elderly_name: string().required("Obrigatório"),

  admin_id: string().required("Obrigatório"),

  valence_id: string().required("Obrigatório"),

  country_id: string().required("Obrigatório"),

  source_id: string().required("Obrigatório"),

  type_search_id: string().required("Obrigatório"),

  request_period_id: string().required("Obrigatório"),

  closest_county: string().required("Obrigatório"),

  closest_parish: string().required("Obrigatório"),
});

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

export class NewRequestCard extends React.Component {
  constructor() {
    super();
    this.api = new Api();
  }

  render() {
    const {
      name,
      is_urgent,
      elderly_name,
      admin_id,
      social_worker_id,
      subject,
      request_period_id,
      country_id,
      source_id,
      type_search_id,
      valence_id,
      closest_county,
      closest_parish,
      date_of_birth,
      retirement_pension,
    } = this.props.request;
    return (
      <>
        <Paper square>
          <Table aria-labelledby="tableTitle" />
          <Typography variant="h6" id="tableTitle" className="card-title">
            Dados Gerais
          </Typography>
          <Formik
            initialValues={{
              name: name || "",
              is_urgent,
              elderly_name: elderly_name || "",
              admin_id: admin_id || localStorage.id,
              social_worker_id: social_worker_id || "",
              relatedness: "",
              message: "",
              subject: subject || "",
              request_type: "Exclusivo",
              request_period_id: request_period_id || "",
              country_id: country_id || 1,
              source_id: source_id || 2,
              type_search_id: type_search_id || "",
              valence_id: valence_id || 2,
              search_all_counties: "",
              closest_county: closest_county || "",
              closest_parish: closest_parish || "",
              date_of_birth: date_of_birth || "",
              retirement_pension: retirement_pension || "",
            }}
            // onSubmit={(values, { setSubmitting }) => {
            //   setTimeout(() => {
            //     values.date_of_birth = moment(values.date_of_birth).format('YYYY-MM-DD HH:mm');
            //     console.log(JSON.stringify(values, null, 2));
            //     setSubmitting(false);
            //   }, 400);
            // }}
            onSubmit={this.props.handleSubmit}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            render={({
              values,
              errors,
              status,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
            }) => {
              return (
                <Grid item md={12}>
                  <Form onSubmit={handleSubmit}>
                    <Grid container className="new-card">
                      <Grid item sm={4} className="new-card-inner">
                        <Field
                          name="admin_id"
                          label="Consultor"
                          search
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          value={"" + values.admin_id}
                          optionsFetcher={adminOptionsPromise}
                          component={MaterialSelectFormik}
                        />
                      </Grid>
                      <Grid item md={4} className="new-card-inner">
                        <MaterialSelectFormik
                          name="country_id"
                          label="Pais de origem"
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          value={values.country_id}
                          optionsFetcher={countriesOptionsPromise}
                        />
                      </Grid>

                      <Grid item sm={4} className="new-card-inner">
                        <MaterialSelectFormik
                          name="source_id"
                          label="Origem"
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          value={values.source_id}
                          optionsFetcher={sourcesOptionsPromise}
                        />
                      </Grid>

                      <Grid item sm={4} className="new-card-inner">
                        <br />
                        <MaterialSelectFormik
                          name="type_search_id"
                          label="Tipo de Pesquisa"
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          value={values.type_search_id}
                          optionsFetcher={type_searchesOptionsPromise}
                        />
                      </Grid>

                      <Grid item md={4} className="new-card-inner">
                        <br />
                        <Field
                          name="request_period_id"
                          onChange={setFieldValue}
                          label="Data Pretendida de Admissão"
                          onBlur={setFieldTouched}
                          value={"" + values.request_period_id}
                          options={REQUEST_PERIODS}
                          component={MaterialSelectFormik}
                        />
                      </Grid>
                      <Grid item md={4} className="new-card-inner">
                        <br />
                        <Field
                          name="elderly_name"
                          label="Nome do Idoso"
                          variant="outlined"
                          type="text"
                          onChange={(e) =>
                            onNameChange(e, setFieldValue, values)
                          }
                          component={TriggeringTextField}
                          fullWidth
                          onKeyPress={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                          }}
                        />
                      </Grid>
                      <Grid item md={4} className="new-card-inner">
                        <br />
                        <MaterialSelectFormik
                          name="valence_id"
                          placeholder="valence_id"
                          onChange={setFieldValue}
                          label="Valência"
                          onBlur={setFieldTouched}
                          value={"" + values.valence_id}
                          optionsFetcher={valencesOptionsPromise}
                        />
                      </Grid>

                      <Grid item md={4} className="new-card-inner mt-2">
                        <Field
                          name="date_of_birth"
                          label="Data de nascimento do idoso"
                          type="date"
                          variant="outlined"
                          margin="normal"
                          component={TextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          shrink
                          required
                        />
                      </Grid>
                      <Grid item md={4} className="new-card-inner mt-2">
                        <Field
                          name="retirement_pension"
                          label="Reforma do Idoso (em €)"
                          type="number"
                          variant="outlined"
                          margin="normal"
                          component={TextField}
                          onChange={setFieldValue}
                          value={"" + values.retirement_pension}
                          fullWidth
                        />
                      </Grid>

                      <Grid item md={4} className="new-card-inner mt-3">
                        <Field
                          name="relatedness"
                          value={values.relatedness}
                          label="Parentesco"
                          optionsFetcher={relatednessOptionsPromise}
                          onChange={setFieldValue}
                          component={MaterialSelectFormik}
                        />
                      </Grid>

                      <Grid item md={4} className="new-card-inner mt-3">
                        <div
                          onClick={() => {
                            values.closest_parish = "";
                          }}
                        >
                          <FastField
                            name="closest_county"
                            placeholder="search_county"
                            label="Concelho"
                            onChange={setFieldValue}
                            value={values.closest_county}
                            limit={20}
                            minLength={3}
                            optionsFetcher={countiesOptionsPromise}
                            component={MaterialSelectFormik}
                            required
                          />
                        </div>
                      </Grid>
                      <Grid item md={4} className="new-card-inner mt-3">
                        {values.closest_county && (
                          <FastField
                            name="closest_parish"
                            placeholder="search_parishes"
                            label="Freguesia *"
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            value={values.closest_parish}
                            limit={20}
                            minLength={3}
                            optionsFetcher={parishesOptionsPromise(
                              values.closest_county
                            )}
                            dependsOn="closest_county"
                            shouldUpdate={shouldUpdateSelect}
                            component={MaterialSelectFormik}
                            margin="none"
                            required
                          />
                        )}
                      </Grid>

                      <Grid
                        item
                        md={12}
                        className="new-card-inner"
                        style={{ marginTop: "30px" }}
                      >
                        <Field
                          name="subject"
                          label="Assunto"
                          variant="outlined"
                          margin="normal"
                          type="text"
                          component={TextField}
                          multiline
                          fullWidth
                        />
                        <Paper className="paper-notes">
                          Será preenchido automaticamente em pedidos
                          encaminhados quando for guardado o nome do idoso.
                        </Paper>
                      </Grid>

                      {/* <Grid item md={12} className="new-card-inner">
                          <Field
                            name="message"
                            label="Mensagem"
                            variant="outlined"
                            margin="normal"
                            type="text"
                            component={TextField}
                            multiline={true}
                            fullWidth
                            rows="5"
                            hidden
                          />
                      </Grid> */}
                    </Grid>

                    <Divider />
                    <Grid
                      container
                      className="expansion"
                      style={{ marginBottom: "100px" }}
                    >
                      <Button type="submit" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Grid>
                  </Form>
                </Grid>
              );
            }}
          />
        </Paper>
      </>
    );
  }
}
